import React from "react";
import CustomSelect from "../custom-select/CustomSelect";

interface CreateAdInputProps {
  inputType: string;
  inputLabel: string;
  optionList?: any[];
  value: string | number;
  handleInputChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
    stateName: string,
    inputType: string
  ) => void;
  stateName: string;
  isRequired: boolean;
}

function CreateAdInput({
  inputType,
  inputLabel,
  optionList,
  value,
  handleInputChange,
  stateName,
  isRequired,
}: CreateAdInputProps) {
  if (inputType === "select") {
    return (
      <div className="mb-3">
        <CustomSelect
          id={`customSelect_${inputLabel}`}
          label={inputLabel}
          value={String(value ?? "")}
          options={optionList ?? []}
          onChange={(val) => {
            const syntheticEvent = {
              target: { value: val },
            } as React.ChangeEvent<HTMLSelectElement>;
            handleInputChange(syntheticEvent, stateName, inputType);
          }}
          isRequired={isRequired}
        />
      </div>
    );
  }

  return (
    <div className="form-floating mb-3">
      <input
        type="text"
        className="form-control"
        id={`floatingInput_${inputLabel}`}
        value={value}
        onChange={(e) => handleInputChange(e, stateName, inputType)}
        placeholder={inputLabel}
        min={inputType === "number" ? "0" : undefined}
        maxLength={stateName === "year" ? 4 : undefined}
      />
      <label htmlFor={`floatingInput_${inputLabel}`}>
        {inputLabel}
        <span className="text-danger">{isRequired && "*"}</span>
      </label>
    </div>
  );
}

export default CreateAdInput;
